class Type8Credits {

    constructor(triggerSelector = '.type8_open', template = null) {
        this.triggerSelector = triggerSelector;
        const baseTemplate = '<div class="type8credits"> <div class="type8credits_bg"></div> <div class="type8credits_box"> <div class="type8credits_topbar"> <div> <a href="https://type8.studio" target="_blank"><strong>type8</strong>.studio</a> ///////////// <strong>crédits</strong> </div> <button type="button" class="type8credits_close">X</button> </div> <div class="type8credits_video"> <video class="nopreload" src="https://credits.type8.studio/credits.mp4" loop playsinline></video> <a href="https://type8.studio" class="type8credits_video_link" target="_blank"></a> </div> </div> </div>';
        this.template = template ? template : baseTemplate;

        this.insertTemplate();
        this.initDOM();
        this.initEvents();
    }

    insertTemplate () {
        const wrap = document.createElement('div');
        wrap.innerHTML = this.template;
        document.body.appendChild(wrap);
    }

    initDOM () {
        this.DOM = {
            parent: document.querySelector('.type8credits'),
            bg: document.querySelector('.type8credits_bg'),
            close: document.querySelector('.type8credits_close'),
            video: document.querySelector('.type8credits_video video'),
            links: document.querySelectorAll(this.triggerSelector)
        };
    }

    initEvents () {
        this.DOM.links.forEach((elt) => {
            elt.addEventListener('click', (e) => {
                e.preventDefault();
                this.open()
            });
        })

        this.DOM.bg.addEventListener('click', () => this.close());
        this.DOM.close.addEventListener('click', () => this.close());
    }

    open () {
        this.DOM.parent.classList.add('visible');
        this.DOM.video.play();
    }

    close () {
        this.DOM.parent.classList.remove('visible');
        this.DOM.video.pause();
    }

}

export default Type8Credits;